// @flow
import * as React from 'react';
import { Button } from 'grommet';
import styled from 'styled-components';
import { FormUp } from 'grommet-icons';

type Props = {
    plain: boolean,
}

const StyledButton = styled(Button)`
    height: 32px;
    width: 32px;
    padding: 4px;
`;

const StyledFormArrowClose = styled(FormUp)`
    stroke: #c9cbd1;
    height: 25px;
    width: 25px;
    :hover {stroke: #6d7482}
`;

const StyledArrowCloseButton = (props: Props) => {
    const { plain } = props;
    return (
        <StyledButton plain={plain}>
            <StyledFormArrowClose />
        </StyledButton>
    );
};

export default StyledArrowCloseButton;
